import React, { FC } from "react";
import { Variants } from "../..";
import { linkButtonDefaultProps, LinkButtonProps } from "./link";

export const LinkButtonSecondary: FC<LinkButtonProps> = ({
  children,
  ...props
}: LinkButtonProps) => (
  <Variants.ButtonSecondary as="a" {...props}>
    {children}
  </Variants.ButtonSecondary>
);
LinkButtonSecondary.defaultProps = linkButtonDefaultProps;
